import { CredenzaSuiClient } from '@credenza3/contracts-lib-sui/client'
import { CredenzaSuiSigner, getCredenzaSuiSigner } from '@credenza3/contracts-lib-sui/signer'
import { sdk } from '@lib/sdk/sdk'
import { NetworkTypes } from '@packages/utils/enums'

let signer: CredenzaSuiSigner
const clientsMap = new Map<string, CredenzaSuiClient>()
const initSuiSigner = async (accessToken: string) => {
  if (!accessToken || signer) return
  signer = await getCredenzaSuiSigner({ accessToken, sponsoredTransactions: true })
}

const initSuiClient = async (
  packageId: string,
  networkType: string = NetworkTypes.MAINNET,
): Promise<CredenzaSuiClient> => {
  if (!signer) await initSuiSigner(sdk.getAccessToken() as string)
  if (clientsMap.has(packageId)) return clientsMap.get(packageId) as CredenzaSuiClient

  const client = new CredenzaSuiClient({
    environment: networkType.toUpperCase(),
    packageId,
    signer,
  })

  clientsMap.set(packageId, client)
  return client
}

export { initSuiSigner, initSuiClient }
